import React from 'react'
import moment from 'moment-js'

import { motion } from 'framer-motion'

import { CgPlayListRemove } from 'react-icons/cg'
 

const variants = {
    init: {
        // opacity: 0,
        display: 'none',
        transition: {
            duration: 0
        }
    },
    hover : {
        display: 'block',
        transition: {
            duration: 0
        }
    }
}


const Track = ({item, index, play, owned, remove}) => {
    if(!item) return <></>;
  
    const { artists, name, album, duration_ms } = item

    const msToHH = (ms) => {
         // 1- Convert to seconds:
            let seconds = ms / 1000;
            // 2- Extract hours:
            let hours = parseInt( seconds / 3600 ); // 3,600 seconds in 1 hour
            seconds = seconds % 3600; // seconds remaining after extracting hours
            // 3- Extract minutes:
            let minutes = parseInt( seconds / 60 ); // 60 seconds in 1 minute
            // 4- Keep only seconds not extracted to minutes:
            seconds = parseInt(seconds % 60);
            return ( (minutes < 10 ? `0${minutes}` : minutes)+":"+(seconds < 10 ? `0${seconds}` : seconds));
    }
    const time = (msToHH(duration_ms))

    return (
        <motion.div whileHover='hover' className="playlist__track">
            <h3 className="track__index">{index}</h3>
            <h3 className="track__name">{name}</h3>
            <h3 className="track__artist">{artists[0].name}</h3>
            <h3 className="track__album">{album.name}</h3>
            <h3 className="track__duration">{time}</h3>
            <motion.button variants={variants} initial='init' className="track__button" onClick={play}>PREVIEW</motion.button>
            {/* {owned && <motion.div onClick={() => remove(item)} variants={variants} initial='init' className="button_delete">
                <CgPlayListRemove title="remove from playlist" size="20"/>
            </motion.div> } */}
        </motion.div>
    );
}

export default Track;
